import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

export type OpenModalProps = {
    videoId: string;
    videoUrl: string;
    position?: number;
    extraQuery?: {
        [id: string]: string | number;
    };
    children: React.ReactChild;
};

const OpenModal: React.FC<OpenModalProps> = ({ videoId, videoUrl, position, extraQuery, children }) => {
    const query = { modalId: videoId } as any;
    const router = useRouter();

    if (position) {
        query.position = position;
    }

    return (
        <Link
            href={{
                pathname: videoUrl,
                query: { ...query, ...extraQuery },
            }}
            scroll={false}
            shallow
            passHref
            replace={Boolean(router.query.modalId)}
        >
            {children}
        </Link>
    );
};

export default OpenModal;
